import { IChallenges } from "../../ISearch";

export const challengesEn: Array<IChallenges> = [
  {
    title: "New me challenge",
    href: "/newme",
    imageSrc: {
      desktop:
        "https://i.dietdoctor.com/wp-content/uploads/2022/12/New-me_desktop.png?w=400&h=400&auto=compress%2Cformat",
      mobile:
        "https://i.dietdoctor.com/wp-content/uploads/2022/12/New-me_mobile.png?auto=compress%2Cformat"
    }
  },
  {
    title: "The diabetes program 10 weeks to better blood sugar",
    href: "/diabetes-program",
    imageSrc: {
      desktop:
        "https://i.dietdoctor.com/wp-content/uploads/2023/03/the_diabetes_program_desktop.jpg?w=400&h=400&auto=compress%2Cformat",
      mobile:
        "https://i.dietdoctor.com/wp-content/uploads/2023/03/the_diabetes_program_mobile.jpg?auto=compress%2Cformat"
    }
  }
];
